import { LuneTheme as luneTheme } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Image from 'next/image'
import { useMemo, useState } from 'react'

import { funnelBreakpointBumps } from '@/components/ProjectFunnel/ProjectFunnel'
import useCustomDevice from '@/hooks/useCustomDevice'

// eslint-disable-next-line complexity
const ProjectFunnelItem = ({
    title,
    description,
    image,
    index,
}: {
    title: string
    description: string
    image: string
    index: number
}) => {
    const { mdScreen, smScreen, xsScreen } = useCustomDevice(funnelBreakpointBumps)
    const [isHoveringOverItem, setIsHoveringOverItem] = useState(false)

    const unitWidth = useMemo(() => {
        if (mdScreen) {
            return `auto`
        }

        if (smScreen) {
            return 376
        }

        if (xsScreen) {
            return `auto`
        }

        return 180
    }, [mdScreen, smScreen, xsScreen])

    return (
        <Box
            onMouseOver={() => setIsHoveringOverItem(true)}
            onMouseLeave={() => setIsHoveringOverItem(false)}
            width={unitWidth}
            sx={{
                display: 'flex',
                flexDirection: xsScreen ? 'row' : 'column',
                justifyContent: xsScreen ? 'end' : 'center',
                alignItems: xsScreen ? 'end' : 'start',
                ...(xsScreen && { width: 'auto' }),
                color:
                    isHoveringOverItem || smScreen
                        ? luneTheme.palette.Grey900
                        : luneTheme.palette.Grey500,
                transition: `all 0.3s ease-in-out`,
            }}
        >
            <Image
                style={{
                    filter: isHoveringOverItem || smScreen ? `grayscale(0%)` : `grayscale(100%)`,
                    transition: `all 0.3s ease-in-out`,
                    willChange: 'filter',
                }}
                width={180}
                height={240}
                src={image}
                alt={`Project Funnel`}
            />
            <Box
                sx={{
                    ...(xsScreen && {
                        ml: 3,
                    }),
                    mt: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: `8px`,
                    fontFamily: `Space Grotesk`,
                }}
            >
                <Box
                    sx={{
                        width: `100%`,
                        textAlign: `start`,
                        fontSize: `16px`,
                        fontWeight: `700`,
                    }}
                >
                    {index + 1}.
                </Box>
                <Box
                    sx={{
                        mt: 0,
                        fontSize: `12px`,
                        fontWeight: `700`,
                        textAlign: `start`,
                        width: `100%`,
                        lineHeight: `14.4px`,
                    }}
                >
                    {title}
                </Box>
                <Box
                    sx={{
                        mt: 0,
                        fontSize: `12px`,
                        fontWeight: `400`,
                        lineHeight: `14.4px`,
                    }}
                >
                    {description}
                </Box>
            </Box>
        </Box>
    )
}

export default ProjectFunnelItem
